import {
  Checkbox,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";
import Check from "assets/images/pricing/Check.png";
import Group45 from "assets/images/pricing/Group45.png";
import messageIcon from "assets/images/pricing/Message.png";
import callIcon from "assets/images/pricing/Call.png";
// import Whatsapp from "assets/images/pricing/Whatsapp.png";
import Whatsapp from "assets/images/home-page-images/WhatsappNew.png";

import MDButton from "components/MDButton";
import { Container } from "@mui/material";
import DemoRequestForm from "./components/DemoRequestForm";
import Header from "./components/header";
import Footer from "./components/footer.js";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  return (
    <MDBox
      sx={{
        width: "100%",
        maxWidth: {
          xs: "100%",
          md: "1580px",
          xl: "1920px",
        },
        mx: "auto",
        // px: 2,
      }}
    >
      <Helmet>
        <title> Contact TavloAI | Let’s Talk Growth for Your Venue</title>
        <meta
          name="description"
          content="        Contact Us Page	Reach out to TavloAI’s team for questions, demos, or support. We’re here to help your restaurant, cafe, or bar grow with our AI-powered platform."
        />
        <meta name="keywords" content="	Contact TavloAI" />
      </Helmet>
      <Header></Header>
      <MDBox
        sx={{
          py: 3,
          mt: { xs: 7, sm: 4, md: 16 },

          backgroundColor: "#fff",
        }}
      >
        <MDBox sx={{ width: "96%", margin: "auto" }}>
          <Grid container spacing={4} alignItems="start">
            {/* Left Side */}
            <Grid item xs={7} md={7}>
              <MDBox
                sx={{
                  width: { xs: "100%", sm: "90%", md: "86%" },
                  ml: { xs: "10px", sm: "auto", md: "auto" },
                  // ml: "auto",
                  mt: { xs: 0, sm: 8, md: 8 },
                  textAlign: "start",
                  // border:"1px solid red",
                }}
              >
                <MDBox
                  sx={{
                    pt: { xs: 0.5, sm: 0 },
                    width: "80%",
                    fontWeight: { xs: 600, sm: 600, md: 700 },
                    fontSize: { xs: "15px", sm: "32px", md: "32px" },
                    lineHeight: { xs: "17px", sm: "32px", md: "45px" },
                    color: "#318BEC",
                    fontFamily: "Poppins",
                  }}
                >
                  Contact Us for your <br></br>Restaurant Need
                </MDBox>

                <MDTypography
                  sx={{
                    mt: { xs: 0.4, sm: 2, md: 2 },
                    fontWeight: 400,
                    fontSize: { xs: "10px", sm: "16px", md: "16px" },
                    width: { xs: "100%", sm: "80%", md: "90%" },
                    lineHeight: { xs: "18px", sm: "auto", md: "auto" },

                    textAlign: "start",
                    color: "#000",
                    lineHeight: 1.5,
                    fontFamily: "Poppins",
                  }}
                >
                  <MDBox
                    sx={{
                      fontSize: { xs: "10.5px", sm: "16px", md: "16.5px" },
                      lineHeight: { xs: "18px", sm: "auto", md: "auto" },

                      display: "inline",
                      color: "#000",
                      fontWeight: 800,
                      fontFamily: "Poppins",
                    }}
                  >
                    Have questions?{" "}
                  </MDBox>
                  {/* Desktop  */}
                  <MDBox
                    component="span"
                    sx={{
                      display: { xs: "none", sm: "inline", md: "inline" },
                      color: "#000",
                      fontFamily: "Poppins",
                    }}
                  >
                    or ready to grow your restaurant with <br></br>AI-Powered
                    Growth?
                  </MDBox>
                  {/* mobile  */}
                  <MDBox
                    component="span"
                    sx={{
                      display: { xs: "inline", sm: "none", md: "none" },
                      color: "#000",
                      fontFamily: "Poppins",
                    }}
                  >
                    or ready to grow your restaurant with AI-Powered Growth?
                  </MDBox>
                </MDTypography>

                <MDTypography
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: "10px", sm: "16px", md: "16px" },
                    width: { xs: "100%", sm: "80%", md: "90%" },
                    lineHeight: { xs: "18px", sm: "auto", md: "auto" },

                    textAlign: "start",
                    color: "#000",
                    lineHeight: 1.5,
                    fontFamily: "Poppins",
                    mb: 3.5,
                  }}
                >
                  <MDBox
                    sx={{
                      fontSize: { xs: "10.5px", sm: "16px", md: "16.5px" },
                      lineHeight: { xs: "18px", sm: "auto", md: "auto" },
                      display: "inline",
                      color: "#000",
                      fontFamily: "Poppins",
                      fontWeight: 800,
                    }}
                  >
                    Contact us today:{" "}
                  </MDBox>
                  {/* Desktop  */}
                  <MDBox
                    component="span"
                    sx={{
                      display: { xs: "none", sm: "inline", md: "inline" },
                      fontWeight: 400,
                      color: "#000",
                      fontFamily: "Poppins",
                    }}
                  >
                    We’re here to help you every step of<br></br> the way.
                  </MDBox>
                  {/* Mobile  */}
                  <MDBox
                    component="span"
                    sx={{
                      display: { xs: "inline", sm: "none", md: "none" },
                      fontWeight: 400,
                      color: "#000",
                      fontFamily: "Poppins",
                    }}
                  >
                    We’re here to help you every step of the way.
                  </MDBox>
                </MDTypography>

                <MDBox
                  sx={{
                    display: { xs: "none", sm: "flex", md: "flex" },
                    mt: 4,
                    width: "100%",
                    margin: "auto",
                    // display: "flex",
                    gap: { xs: 2, sm: 2, md: "20px" },
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: "center",
                    justifyContent: { xs: "center", sm: "start" },
                    textAlign: "center",
                  }}
                >
                  <MDBox
                    sx={{
                      background: "#54A6FF",
                      pl: 5,
                      width: "55%",
                      maxWidth: "650px",
                      height: "145px",
                      display: "flex",
                      gap: 3,
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "10px",
                      boxShadow: "1px 2px 12px -1px #0000008C",
                      // boxShadow: "3px 4px 24px -1px #0000008C",
                    }}
                  >
                    {/* Phone Section */}
                    <MDBox
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                        width: "100%",
                      }}
                    >
                      <img
                        src={callIcon}
                        alt="Call icon"
                        style={{ width: "30px", height: "30px" }}
                      />
                      <MDTypography
                        sx={{
                          color: "#fff",
                          fontSize: "16px",
                          fontFamily: "Inter",
                          fontWeight: 600,
                        }}
                      >
                        (202)240-7754
                      </MDTypography>
                    </MDBox>

                    {/* Email Section */}
                    <MDBox
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                        width: "100%",
                      }}
                    >
                      <img
                        src={messageIcon}
                        alt="Email icon"
                        style={{ width: "30px", height: "25px" }}
                      />
                      <MDTypography
                        sx={{
                          color: "#fff",
                          fontSize: "16px",
                          fontFamily: "Inter",
                          wordBreak: "break-word",
                          fontWeight: 600,
                        }}
                      >
                        info@gratitudesystems.com
                      </MDTypography>
                    </MDBox>
                  </MDBox>

                  {/* WhatsApp */}
                  {/* <MDBox
                    sx={{
                      background: "#25D366",
                      px: 3,
                      py: 3,
                      width: "41%",
                      maxWidth: "320px",
                      height: "145px",
                      borderRadius: "10px",
                      boxShadow: "1px 2px 12px -1px #0000008C",
                    }}
                  >
                    <MDBox
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        alignItems: "center",
                        cursor: "pointer",
                        transition: "transform 0.6s ease",
                        pt: 1,
                        "&:hover": {
                          transform: "scale(1.1)",
                          // You can adjust scale to your liking
                        },
                        "& img": {
                          transition: "transform 0.6s ease",
                        },
                        "&:hover img": {
                          transform: "scale(1.0)", // optional: make icon scale a bit more
                        },
                        "& .text": {
                          transition: "transform 0.5s ease",
                          color: "#fff",
                          padding: "4px 32px",
                          borderRadius: "10px",
                          fontSize: "16px",
                          fontFamily: "Inter",
                          fontWeight: 600,
                          textTransform: "none",
                        },
                        "&:hover .text": {
                          transform: "scale(1.05)",
                        },
                      }}
                    >
                      <img
                        src={Whatsapp}
                        alt="WhatsApp icon"
                        style={{ width: "50px" }}
                      />
                      <MDBox className="text">WhatsApp Now</MDBox>
                    </MDBox>
                  </MDBox> */}
                </MDBox>
              </MDBox>
            </Grid>

            {/* Right Side: Image */}
            <Grid
              item
              xs={5}
              md={5}
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "center" },
                alignItems: "flex-end",
              }}
            >
              <MDBox
                component="img"
                src={Group45}
                alt="AI dashboard"
                sx={{
                  pb: 1,
                  width: { xs: "126px", sm: "100%", md: "100%" },
                  maxWidth: "469px",
                  // height: { xs: "380px", sm: "360px", md: "420px" },
                  borderRadius: "16px",
                  // objectFit: "cover",
                }}
              />
            </Grid>
          </Grid>
          <MDBox
            sx={{
              display: { xs: "flex", sm: "none", md: "none" },
              pl: { xs: "10px", sm: "auto", md: "auto" },
              pr: "10px",

              width: "100%",
              gap: { xs: 2, sm: 2, md: 3 },
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "start", // Center horizontally
              textAlign: "center",
              flexWrap: "wrap", // Allows wrapping on small screens
            }}
          >
            {/* Phone & Email Box */}
            <MDBox
              sx={{
                background: "#54A6FF",
                pl: { xs: 2, sm: 5, md: 5 },
                width: { xs: "60%", sm: "48%", md: "45%" },
                height: "72px",
                display: "flex",
                gap: 1,
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
                borderRadius: "6px",
                boxShadow: "3px 4px 24px -1px #0000008C",
              }}
            >
              {/* Phone Section */}
              <MDBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  width: "fit-content",
                }}
              >
                <img
                  src={callIcon}
                  alt="Call icon"
                  style={{
                    width: "14px",
                    height: "14px",
                  }}
                />
                <MDTypography
                  sx={{
                    color: "#fff",
                    fontSize: { xs: "10px", sm: "16px" },
                    fontFamily: "Inter",
                    fontWeight: 600,
                  }}
                >
                  (202)240-7754
                </MDTypography>
              </MDBox>

              {/* Email Section */}
              <MDBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  width: "fit-content",
                }}
              >
                <img
                  src={messageIcon}
                  alt="Email icon"
                  style={{
                    width: "14px",
                    height: "14px",
                  }}
                />
                <MDTypography
                  sx={{
                    color: "#fff",
                    fontSize: "10px",
                    fontFamily: "Inter",
                    wordBreak: "break-word",
                    fontWeight: 600,
                  }}
                >
                  info@gratitudesystems.com
                </MDTypography>
              </MDBox>
            </MDBox>

            {/* WhatsApp Box */}
            {/* <MDBox
              sx={{
                background: "#25D366",
                px: 1,
                py: 1,
                width: { xs: "35%", sm: "48%", md: "30%" },
                maxWidth: "190px",
                height: "72px",
                borderRadius: "6px",
                boxShadow: "3px 4px 24px -1px #0000008C",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={Whatsapp}
                alt="WhatsApp icon"
                style={{ width: "28px" }}
              />
              <MDTypography
                sx={{
                  color: "#fff",
                  mt: 1,
                  fontSize: "10px",
                  fontFamily: "Inter",
                  fontWeight: 600,
                  textTransform: "none",
                }}
              >
                WhatsApp Now
              </MDTypography>
            </MDBox> */}
          </MDBox>
        </MDBox>
      </MDBox>

      <Grid container>
        <Grid
          item
          lg={12}
          sx={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(49, 139, 236, 0.6) 100%)",
            py: { xs: 2, sm: 4, md: 12 },
            width: {
              xs: "100%",
              sm: "90%",
              md: "auto",
            },
            pb: {
              xs: 6,
              sm: 4,
              md: 6,
            },
          }}
        >
          <DemoRequestForm />
        </Grid>
      </Grid>
      <Footer></Footer>
    </MDBox>
  );
};

export default Contact;
